import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {PackingContext} from "../PackingOrderList/PackingContext";
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import TextEmphasisBloc from "../../../../../components/WMS/TextEmphasisBloc";

CustomTrackingNumberModal.propTypes = {
    handleValidation: PropTypes.func.isRequired
};

function CustomTrackingNumberModal({handleValidation, setOpenCustomTrackingNumberModal}) {
    const {shipmentTrackingNumber, setShipmentTrackingNumber, packingLoading} = useContext(PackingContext);

    const handleEdit = (value) => {
        setShipmentTrackingNumber(value)
    }

    return (
        <Popup
            open={true}
            onClose={() => setOpenCustomTrackingNumberModal(false)}
            title={<FormattedMessage id={"picking.order.show.waybillSelector.title"}/>}
        >
            <Grid
                container
                direction={"column"}
                gap={"8px"}
                justifyContent={"end"}
            >
                <Grid
                    container
                    direction={"column"}
                    sx={{border: "1px solid black", borderRadius: "8px", padding: "8px"}}
                    gap={"8px"}
                >
                    <span style={{fontWeight: "bold"}}><FormattedMessage id={"picking.order.show.waybillSelector.self_shipping.title"}/></span>
                    <span><FormattedMessage id={"picking.order.show.waybillSelector.self_shipping.subtitle"}/></span>

                    <TextEmphasisBloc
                        leftPart={shipmentTrackingNumber}
                        placeholder={<FormattedMessage id={"picking.order.show.waybillSelector.self_shipping.number.label"}/>}
                        isEditable={true}
                        editLeftPart={handleEdit}
                    />
                </Grid>

                <Grid container gap={"8px"} flexWrap={"nowrap"}>
                    <CustomButton
                        onClick={() => setOpenCustomTrackingNumberModal(false)}
                        color={"idle"}
                        disabled={packingLoading}
                    >
                        <FormattedMessage id={"wms.packing.modal.customTrackingNumber.cancel"}/>
                    </CustomButton>
                    <CustomButton
                        disabled={packingLoading}
                        onClick={() => {
                            handleValidation()
                        }}
                    >
                        <FormattedMessage id={"wms.packing.modal.customTrackingNumber.confirm"}/>
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default CustomTrackingNumberModal;